export default {
  actions: {
    async setLeagueId({ commit }, leagueIden) {
      commit('newLeagueId', leagueIden);
    },
    async setInterval({ commit }, lang) {
      commit('newLang', lang);
    },
    async setRtl({ commit }, rtl) {
      commit('newRtl', rtl);
    },
    async gameCount({ commit }, gameC) {
      commit('gameCo', gameC);
    },
    async gameCountL({ commit }, gameCL) {
      commit('gameCol', gameCL);
    },
    async setdateNtime({ commit }, dateIden) {
      commit('newdateNtime', dateIden);
    },
    async getArray({ commit, state },) {
      const res = await fetch('https://sportapi.zuniac.com/favorites?timezone=%2B04%3A00&token=' + state.token.token);
      const data = await res.json();
      const favs = data.teams;
      const favsT = data.tournaments;
      const favsTe = data.matches;
      commit('updateArray', favs);
      commit('updateArrayT', favsT);
      commit('updateArrayTe', favsTe);
    },
    async getBalance({ commit, state }) {
      var myHeaders = new Headers();
      myHeaders.append("Cookie", "__cfduid=daa11664c49161bf93cd02dbd6c4fb8131611146765");

      var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(state.httpReq + '/user/me?token=' + state.token.token, requestOptions)
        .then(response => response.json())
        .then(result => {
          var balance = result.user.score;
          // document.cookie = 'balance =' + result.user.score;
          // this.selLanguage = result.user.language;
          // console.log(balance)
          commit('balanceF', balance);

        })
        .catch(error => console.log('error', error));

    },

    // async getArrayT({ commit, state},){
    //   const res = await fetch('https://sportapi.zuniac.com/favorites?timezone=%2B04%3A00&token=' + state.token.token);
    //   const data = await res.json();
    //   const favsT = data.tournaments;
    //       commit('updateArrayT', favsT);
    //   },  
    //   async getArrayTe({ commit, state},){
    //     const res = await fetch('https://sportapi.zuniac.com/favorites?timezone=%2B04%3A00&token=' + state.token.token);
    //     const data = await res.json();
    //     const favsTe = data.matches;
    //         commit('updateArrayTe', favsTe);
    //     },  

    async removeFavorite({ dispatch, state }, value) {
      var myHeaders = new Headers();
      myHeaders.append("Cookie", "__cfduid=d0fd030adfcb3ad72f89a1229479eea4c1595402997");

      var requestOptions = {
        method: 'DELETE',
        headers: myHeaders,
        redirect: 'follow'
      };


      fetch("https://sportapi.zuniac.com/favorite?elementId=" + value.value + "&elementType=" + value.type + "&token=" + state.token.token, requestOptions)
        .then(response => response.text())
        .then(result => {
          console.log(1, result);
          dispatch("getArray");
        })
        .then(console.log(value))

        .catch(error => console.log('error', error));

      // this.fetchData();
    },
    async addToFavorites({ dispatch, state }, value) {
      fetch('https://sportapi.zuniac.com/favorite?elementId=' + value.value + '&elementType=' + value.type + '&token=' + state.token.token, { method: 'post' })
        .then(result => {
          console.log(1, result);
          dispatch("getArray");
        })
    },

  },
  mutations: {
    newLeagueId: (state, leagueIden) => state.leagueIDe = leagueIden,
    newdateNtime: (state, dateIden) => state.dateNtime = dateIden,
    newLang: (state, lang) => state.lang = lang,
    newRtl: (state, rtl) => state.rtl = rtl,
    gameCo: (state, gameC) => state.gameC = gameC,
    gameCol: (state, gameCL) => state.gameCL = gameCL,
    balanceF: (state, balance) => state.balance = balance,
    updateArray(state, favs) {
      state.favs = favs;
    },
    updateArrayT(state, favsT) {
      state.favsT = favsT;
    },
    updateArrayTe(state, favsTe) {
      state.favsTe = favsTe;
    },
  },
  state: {
    leagueIDe: '',
    dateNtime: '',
    favs: [],
    favsT: [],
    favsTe: [],
    token: document.cookie.split(';').map(cookie => cookie.split('=')).reduce((accumulator, [key, value]) => ({ ...accumulator, [key.trim()]: decodeURIComponent(value) }), {}),
    lang: '',
    httpReq: 'https://sportapi.zuniac.com',
    gameC: '',
    gameCL: '',
    gameCF: '',
    balance: '',
    rtl: 0,
  },
  getters: {
    leagueIDe: (state) => state.leagueIDe,
    dateNtime: (state) => state.dateNtime,
    favs: (state) => state.favs,
    favsT: (state) => state.favsT,
    favsTe: (state) => state.favsTe,
    token: (state) => state.token,
    rtl: (state) => state.rtl,
    lang: (state) => state.lang,
    httpReq: (state) => state.httpReq,
    balance: (state) => state.balance,
    gameC: (state) => state.gameC,
    gameCL: (state) => state.gameCL,
    gameCF: (state) => state.favsTe.length,
  },
}